import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 20223-09-07
 * @brief SEI 메뉴 관리 개발
 *
 ********************************************************************/
import { useState } from "react";
function SiteTree() {
    const [menuList, setMenuList] = useState([{ menuId: 0, menuName: "메뉴별 권한 설정", adminType: "AUTH" }]);
    function onClickGoMenu(e, menu) {
        e.stopPropagation();
    }
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: "box treebar pushy-menutype type3 h-auto" }, { children: _jsx("div", Object.assign({ className: "lnb" }, { children: _jsx("ul", Object.assign({ className: "lnb-depth1" }, { children: menuList.map((menu, idx) => (_jsx("li", Object.assign({ className: menu.menuId === idx ? "active" : "" }, { children: _jsx("p", { children: _jsx("a", Object.assign({ onClick: (e) => onClickGoMenu(e, menu) }, { children: _jsx("span", { children: menu.menuName }) })) }) }), `menu_${idx.toString()}`))) })) })) })) }));
}
export default SiteTree;
